<div class="wizard-container">
  <!-- Header -->
  <div class="wizard-header">
    <h2>{{ 'forms.names.addorder' | translate }}</h2>
    <span *ngIf="brokerReference" class="crm-ref">Ref: {{ brokerReference }}</span>
  </div>

  <!-- Stepper breadcrumb -->
  <div class="wizard-stepper">
    <div *ngFor="let step of steps; let i = index"
      class="step-item"
      [class.active]="i === currentStep"
      [class.completed]="step.valid && i < currentStep"
      [class.clickable]="i < currentStep"
      (click)="goToStep(i)">
      <span class="step-number">{{ i + 1 }}</span>
      <span class="step-label">{{ step.label | translate }}</span>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <!-- Validation failures -->
  <div *ngIf="validationFailures.length > 0" class="alert alert-danger mt-3">
    <div class="validation-error-title"><i class="icon-warning"></i> {{ 'sql_wizard.validation_errors' | translate }}</div>
    <ul class="validation-error-list">
      <li *ngFor="let f of validationFailures">
        {{ f | translate }}
      </li>
    </ul>
  </div>

  <!-- STEP 1: Contrato (accordion: Acuerdo + Vehículo + Contrato) -->
  <div *ngIf="!loading && currentStep === 0" class="wizard-step">

    <!-- Sección: Acuerdo (Supplier + Vendor) -->
    <h5 class="section-title">{{ 'inputs.partnership' | translate }}</h5>
    <div [formGroup]="partnershipForm">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label">{{ 'inputs.supplier' | translate }} <span class="required">*</span></label>
          <ng-select
            [items]="supplierData" bindValue="reference"
            formControlName="supplier_id"
            [placeholder]="'inputs.select_option' | translate"
            [searchable]="true" [clearable]="false"
            [notFoundText]="'tables.no_results' | translate">
            <ng-template ng-label-tmp let-item="item">{{ item.name }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.name }}</ng-template>
          </ng-select>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label">{{ 'inputs.vendor' | translate }} <span class="required">*</span></label>
          <ng-select
            [items]="vendorData" bindValue="reference"
            formControlName="vendor_id"
            [placeholder]="'inputs.select_option' | translate"
            [searchable]="true" [clearable]="false"
            [notFoundText]="'tables.no_results' | translate">
            <ng-template ng-label-tmp let-item="item">{{ item.name }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.name }}</ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row linea"></div>

    <!-- Sección: Vehículo y Contrato -->
    <h5 class="section-title">{{ 'inputs.vehicle' | translate }} & {{ 'inputs.contract' | translate }}</h5>
    <div [formGroup]="vehicleForm">

        <!-- ========== MODO: MANUAL (inputs editables) ========== -->
        <div *ngIf="vehicleMode === 'manual'">
          <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="switchToCampaignSelect()">
              <i class="icon-bullhorn"></i> {{ 'inputs.campaign' | translate }}
            </button>
          </div>

          <!-- Vehicle inputs -->
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'inputs.vehicle_trim' | translate }}</label>
              <input type="text" class="form-control" formControlName="vehicle"
                [placeholder]="'inputs.vehicle_trim' | translate" />
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <label class="form-label">{{ 'inputs.brand' | translate }}</label>
              <ng-select [items]="brands" bindValue="reference" bindLabel="name" formControlName="vehicle_brand_id"
                [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="true"
                [notFoundText]="'tables.no_results' | translate" (change)="onBrandChange($event)">
              </ng-select>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <label class="form-label">{{ 'inputs.model' | translate }}</label>
              <ng-select [items]="models" bindValue="reference" bindLabel="name" formControlName="vehicle_model_id"
                [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="true"
                [notFoundText]="'tables.no_results' | translate">
              </ng-select>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <label class="form-label">{{ 'inputs.vehicle_trim_finish' | translate }}</label>
              <input type="text" class="form-control" formControlName="vehicle_trim" maxlength="150" />
            </div>
            <div class="col-6 col-md-3 mb-3">
              <label class="form-label">{{ 'inputs.year' | translate }}</label>
              <input type="number" class="form-control" formControlName="vehicle_model_year" [placeholder]="'inputs.year' | translate" />
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <label class="form-label">{{ 'inputs.vehicle_status' | translate }}</label>
              <ng-select [items]="vehicleStatusOptions" formControlName="vehicle_status"
                [placeholder]="'inputs.select_option' | translate" [clearable]="true">
                <ng-template ng-label-tmp let-item="item">{{ 'badge-status_select-stage.' + item | translate }}</ng-template>
                <ng-template ng-option-tmp let-item="item">{{ 'badge-status_select-stage.' + item | translate }}</ng-template>
              </ng-select>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <label class="form-label">{{ 'inputs.colour' | translate }}</label>
              <input type="text" class="form-control" formControlName="colour" [placeholder]="'inputs.colour' | translate" />
            </div>
          </div>

          <div class="row linea"></div>

          <!-- Contract inputs -->
          <div class="row">
            <div class="col-6 mb-3">
              <label class="form-label">{{ 'inputs.duration' | translate }}</label>
              <ng-select formControlName="duration" [items]="['12','24','36','48','60','72']"
                [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
                <ng-template ng-label-tmp let-item="item">{{ item }} {{ 'inputs.month' | translate }}</ng-template>
                <ng-template ng-option-tmp let-item="item">{{ item }} {{ 'inputs.month' | translate }}</ng-template>
              </ng-select>
            </div>
            <div class="col-6 mb-3">
              <label class="form-label">{{ 'inputs.type' | translate }}</label>
              <ng-select formControlName="type" [items]="['renting', 'leasing']"
                [placeholder]="'inputs.select_option' | translate" [clearable]="true">
                <ng-template ng-label-tmp let-item="item">{{ 'inputs.' + item | translate }}</ng-template>
                <ng-template ng-option-tmp let-item="item">{{ 'inputs.' + item | translate }}</ng-template>
              </ng-select>
            </div>
          </div>
          <div class="row">
            <div class="col-6 mb-3">
              <label class="form-label">{{ 'inputs.yearly_kms' | translate }}</label>
              <input type="text" class="form-control" formControlName="yearly_kms" />
            </div>
            <div class="col-6 mb-3">
              <label class="form-label">{{ 'inputs.total_kms' | translate }}</label>
              <input type="text" class="form-control" formControlName="total_kms" />
            </div>
          </div>
          <div class="row">
            <div class="col-4 mb-3">
              <label class="form-label">{{ 'inputs.monthly_fee_base' | translate }}</label>
              <input type="number" class="form-control" formControlName="monthly_fee_base" min="0" step="0.01" />
            </div>
            <div class="col-4 mb-3">
              <label class="form-label">{{ 'inputs.monthly_fee_tax' | translate }}</label>
              <input type="number" class="form-control" formControlName="monthly_fee_tax" min="0" step="0.01" />
            </div>
            <div class="col-4 mb-3">
              <label class="form-label">{{ 'inputs.monthly_fee_total' | translate }}</label>
              <input type="number" class="form-control" formControlName="monthly_fee_total" min="0" step="0.01" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-6"><div class="form-check"><input class="form-check-input" type="checkbox" formControlName="include_maintenance" /><label class="form-check-label">{{ 'inputs.maintance' | translate }}</label></div></div>
            <div class="col-6"><div class="form-check"><input class="form-check-input" type="checkbox" formControlName="include_insurance" /><label class="form-check-label">{{ 'inputs.insurance' | translate }}</label></div></div>
            <div class="col-6"><div class="form-check"><input class="form-check-input" type="checkbox" formControlName="include_tires" /><label class="form-check-label">{{ 'inputs.tires' | translate }}</label></div></div>
            <div class="col-6"><div class="form-check"><input class="form-check-input" type="checkbox" formControlName="include_replacement_vehicle" /><label class="form-check-label">{{ 'inputs.replacement_vehicle' | translate }}</label></div></div>
          </div>
          <div class="row">
            <div class="col-6 mb-3">
              <label class="form-label">{{ 'inputs.initial_payment' | translate }}</label>
              <input type="number" class="form-control" formControlName="initial_payment" min="0" step="0.01" />
            </div>
            <div class="col-6 mb-3">
              <label class="form-label">{{ 'inputs.vehicle_discount_code' | translate }}</label>
              <input type="text" class="form-control" formControlName="vehicle_discount_code" />
            </div>
          </div>
        </div>

        <!-- ========== MODO: SELECCIÓN DE CAMPAÑA (selector + matrix) ========== -->
        <div [hidden]="vehicleMode !== 'campaign_select'">
          <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="switchToManual()">
              <i class="icon-pencil"></i> {{ 'inputs.manual' | translate }}
            </button>
          </div>
          <div class="mb-3">
            <label class="form-label">{{ 'inputs.campaign' | translate }}</label>
            <ng-select
              [items]="campaignsData" bindValue="reference" bindLabel="name"
              [(ngModel)]="selectedCampaignRef" [ngModelOptions]="{standalone: true}"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true" [clearable]="true"
              [notFoundText]="'tables.no_results' | translate"
              (change)="onCampaignSelect($event)">
              <ng-template ng-label-tmp let-item="item">{{ item.supplier_name }} - {{ item.name }}</ng-template>
              <ng-template ng-option-tmp let-item="item">{{ item.supplier_name }} - {{ item.name }}</ng-template>
            </ng-select>
          </div>
          <div *ngIf="matrixData && matrixColumns.length > 0">
            <label class="form-label">{{ 'inputs.price_matrix' | translate }}</label>
            <table class="matriz">
              <thead>
                <tr>
                  <th class="cell-no-border"></th>
                  <th *ngFor="let col of matrixColumns">{{ col }} <span class="text-sm">{{ 'inputs.month' | translate }}</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of matrixRows">
                  <th>{{ row | formatNumberPipe3 }} <span class="text-sm">{{ 'inputs.kilometers' | translate }}</span></th>
                  <td *ngFor="let col of matrixColumns">
                    <button type="button"
                      [disabled]="matrixDisplay[col]?.[row] == null"
                      (click)="selectMatrixCell(col, row)"
                      [ngClass]="{ 'selected': selectedMatrixCol === col && selectedMatrixRow === row }">
                      <span *ngIf="matrixDisplay[col]?.[row] != null">
                        {{ matrixDisplay[col]?.[row] | formatNumberPipe }}<span class="text-sm">{{ matrixDisplay[col]?.[row] | formatNumberPipe2 }}</span>
                      </span>
                      <span *ngIf="matrixDisplay[col]?.[row] == null"> - </span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-2">
              <input class="form-check-input" type="checkbox" id="wizard_iva" [checked]="showIva" (change)="onIvaToggle($event)" />
              <label class="form-check-label" for="wizard_iva">{{ 'forms.buttons.iva_included' | translate }}</label>
            </div>
          </div>
        </div>

        <!-- ========== MODO: CAMPAÑA CONFIRMADA (labels readonly) ========== -->
        <div *ngIf="vehicleMode === 'campaign_confirmed'">
          <!-- Nombre campaña + botón Manual arriba -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="campaign-name-label" *ngIf="vehicleForm.value.campaign_reference">
              <i class="icon-bullhorn"></i> {{ vehicleForm.value.campaign_reference }}
            </span>
            <span *ngIf="!vehicleForm.value.campaign_reference"></span>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="switchToManual()">
              <i class="icon-pencil"></i> {{ 'inputs.manual' | translate }}
            </button>
          </div>
          <!-- Labels readonly -->
          <div class="row mb-2">
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.brand' | translate }}</span><span class="label-value">{{ prefillData?.payload?.vehicle_brand || vehicleForm.value.vehicle_brand_id }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.model' | translate }}</span><span class="label-value">{{ prefillData?.payload?.vehicle_model || vehicleForm.value.vehicle_model_id }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.vehicle_trim_finish' | translate }}</span><span class="label-value">{{ vehicleForm.value.vehicle_trim || '—' }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.year' | translate }}</span><span class="label-value">{{ vehicleForm.value.vehicle_model_year || '—' }}</span></div>
          </div>
          <div class="row mb-2">
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.vehicle_trim' | translate }}</span><span class="label-value">{{ vehicleForm.value.vehicle || '—' }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.colour' | translate }}</span><span class="label-value">{{ vehicleForm.value.colour || '—' }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.vehicle_status' | translate }}</span><span class="label-value">{{ vehicleForm.value.vehicle_status ? ('badge-status_select-stage.' + vehicleForm.value.vehicle_status | translate) : '—' }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.type' | translate }}</span><span class="label-value">{{ vehicleForm.value.type ? ('inputs.' + vehicleForm.value.type | translate) : '—' }}</span></div>
          </div>
          <div class="row linea"></div>
          <div class="row mb-2">
            <div class="col-4"><span class="label-title">{{ 'inputs.duration' | translate }}</span><span class="label-value">{{ vehicleForm.value.duration }} {{ 'inputs.month' | translate }}</span></div>
            <div class="col-4"><span class="label-title">{{ 'inputs.yearly_kms' | translate }}</span><span class="label-value">{{ vehicleForm.value.yearly_kms }}</span></div>
            <div class="col-4"><span class="label-title">{{ 'inputs.total_kms' | translate }}</span><span class="label-value">{{ vehicleForm.value.total_kms }}</span></div>
          </div>
          <div class="row mb-2">
            <div class="col-4"><span class="label-title">{{ 'inputs.monthly_fee_base' | translate }}</span><span class="label-value">{{ vehicleForm.value.monthly_fee_base }}</span></div>
            <div class="col-4"><span class="label-title">{{ 'inputs.monthly_fee_tax' | translate }}</span><span class="label-value">{{ vehicleForm.value.monthly_fee_tax }}</span></div>
            <div class="col-4"><span class="label-title">{{ 'inputs.monthly_fee_total' | translate }}</span><span class="label-value">{{ vehicleForm.value.monthly_fee_total }}</span></div>
          </div>
          <div class="row mb-2">
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.maintance' | translate }}</span><span class="label-value">{{ vehicleForm.value.include_maintenance ? '✓' : '✗' }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.insurance' | translate }}</span><span class="label-value">{{ vehicleForm.value.include_insurance ? '✓' : '✗' }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.tires' | translate }}</span><span class="label-value">{{ vehicleForm.value.include_tires ? '✓' : '✗' }}</span></div>
            <div class="col-6 col-md-3"><span class="label-title">{{ 'inputs.replacement_vehicle' | translate }}</span><span class="label-value">{{ vehicleForm.value.include_replacement_vehicle ? '✓' : '✗' }}</span></div>
          </div>
          <!-- Cambiar configuración siempre abajo a la derecha -->
          <div class="d-flex justify-content-end mt-3">
            <a class="link-edit-config" (click)="toggleConfigSelector()">
              <i class="icon-grid"></i> {{ 'forms.buttons.change_configuration' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>

  <!-- STEP 2: Documents -->
  <div *ngIf="!loading && currentStep === 1" class="wizard-step">
    <h5 class="step-title">{{ 'inputs.documents' | translate }}</h5>

    <!-- Tabs -->
    <div class="wizard-doc-tabs">
      <div class="tab-buttons">
        <button class="tab-button" [class.active]="activeDocTab === 'client'" (click)="activeDocTab = 'client'">
          {{ 'inputs.client_documents' | translate }}
        </button>
        <button class="tab-button" [class.active]="activeDocTab === 'order'" (click)="activeDocTab = 'order'">
          {{ 'inputs.order_documents' | translate }}
        </button>
      </div>
    </div>

    <!-- Tab: Client documents -->
    <div *ngIf="activeDocTab === 'client'" class="wizard-doc-content">
      <p class="text-muted small mb-2">{{ 'inputs.upload_dni_hint' | translate }}</p>
      <div class="drop-zone" (drop)="onDropZone($event, 'client')" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
        (click)="clientFileInput.click()">
        {{ 'forms.labels.draganddrop' | translate }}
        <input #clientFileInput type="file" multiple class="input-file-hidden"
          accept=".pdf,.jpg,.jpeg,.png,.csv,.txt,.docx,.doc,.xls,.xlsx,.zip,.rar"
          (change)="onDocumentAdd($event, 'client')" />
      </div>
      <ul *ngIf="clientDocuments.length > 0" class="wizard-doc-list">
        <li *ngFor="let doc of clientDocuments; let i = index" class="listFiles">
          <div class="div-thumbnail">
            <img class="thumbnail" [src]="getFileThumbnail(doc.file)" alt="Thumbnail" />
            <span class="doc-name">{{ doc.file.name }}</span>
            <span class="doc-remove-icon" (click)="removeDocument(i, 'client')"><i class="icon-trash"></i></span>
          </div>
          <div>
            <select class="select-option form-control"
              (change)="onDocumentTypeChange(i, 'client', $any($event.target).value)">
              <option value="">{{ 'inputs.type' | translate }}</option>
              <option *ngFor="let t of clientDocumentTypes" [value]="t.key" [selected]="t.key === doc.type">
                {{ 'select.document_type.' + t.key | translate }}
              </option>
            </select>
          </div>
        </li>
      </ul>
    </div>

    <!-- Tab: Order documents -->
    <div *ngIf="activeDocTab === 'order'" class="wizard-doc-content">
      <p class="text-muted small mb-2">{{ 'inputs.upload_order_docs_hint' | translate }}</p>
      <div class="drop-zone" (drop)="onDropZone($event, 'order')" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
        (click)="orderFileInput.click()">
        {{ 'forms.labels.draganddrop' | translate }}
        <input #orderFileInput type="file" multiple class="input-file-hidden"
          accept=".pdf,.jpg,.jpeg,.png,.csv,.txt,.docx,.doc,.xls,.xlsx,.zip,.rar"
          (change)="onDocumentAdd($event, 'order')" />
      </div>
      <ul *ngIf="orderDocuments.length > 0" class="wizard-doc-list">
        <li *ngFor="let doc of orderDocuments; let i = index" class="listFiles">
          <div class="div-thumbnail">
            <img class="thumbnail" [src]="getFileThumbnail(doc.file)" alt="Thumbnail" />
            <span class="doc-name">{{ doc.file.name }}</span>
            <span class="doc-remove-icon" (click)="removeDocument(i, 'order')"><i class="icon-trash"></i></span>
          </div>
          <div>
            <select class="select-option form-control"
              (change)="onDocumentTypeChange(i, 'order', $any($event.target).value)">
              <option value="">{{ 'inputs.type' | translate }}</option>
              <option *ngFor="let t of orderDocumentTypes" [value]="t.key" [selected]="t.key === doc.type">
                {{ 'select.document_type.' + t.key | translate }}
              </option>
            </select>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- STEP 3: Client -->
  <div *ngIf="!loading && currentStep === 2" class="wizard-step" [formGroup]="clientForm">
    <h5 class="step-title">{{ 'inputs.client' | translate }}</h5>
    <div class="row">
      <div class="col-6 col-md-4 mb-3">
        <label class="form-label">{{ 'inputs.tax_id' | translate }} <span class="required">*</span></label>
        <input type="text" class="form-control" formControlName="tax_id"
          [placeholder]="'inputs.tax_id' | translate" />
      </div>
      <div class="col-6 col-md-4 mb-3">
        <label class="form-label">{{ 'inputs.type' | translate }} <span class="required">*</span></label>
        <ng-select
          [items]="clientTypeOptions"
          formControlName="type"
          [placeholder]="'inputs.select_option' | translate"
          [clearable]="false">
          <ng-template ng-label-tmp let-item="item">{{ 'inputs.' + item | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ 'inputs.' + item | translate }}</ng-template>
        </ng-select>
      </div>
      <div class="col-12 col-md-4 mb-3">
        <label class="form-label">{{ 'inputs.name' | translate }} <span class="required">*</span></label>
        <input type="text" class="form-control" formControlName="name"
          [placeholder]="'inputs.name' | translate" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-3">
        <label class="form-label">{{ 'inputs.lastname' | translate }}</label>
        <input type="text" class="form-control" formControlName="lastname"
          [placeholder]="'inputs.lastname' | translate" />
      </div>
      <div class="col-6 col-md-4 mb-3">
        <label class="form-label">{{ 'inputs.email' | translate }} <span class="required">*</span></label>
        <input type="email" class="form-control" formControlName="email"
          [placeholder]="'inputs.email' | translate" />
      </div>
      <div class="col-6 col-md-4 mb-3">
        <label class="form-label">{{ 'inputs.phone' | translate }} <span class="required">*</span></label>
        <input type="text" class="form-control" formControlName="phone"
          [placeholder]="'(+34)600000000'" />
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-3 mb-3">
        <label class="form-label">{{ 'inputs.nationality' | translate }}</label>
        <input type="text" class="form-control" formControlName="nationality"
          [placeholder]="'inputs.nationality' | translate" />
      </div>
      <div class="col-6 col-md-3 mb-3">
        <label class="form-label">{{ 'inputs.birthplace_country' | translate }}</label>
        <input type="text" class="form-control" formControlName="birthplace_country"
          [placeholder]="'inputs.birthplace_country' | translate" />
      </div>
      <div class="col-6 col-md-3 mb-3">
        <label class="form-label">{{ 'inputs.birth_date' | translate }}</label>
        <input type="date" class="form-control" formControlName="birth_date" />
      </div>
      <div class="col-6 col-md-3 mb-3">
        <label class="form-label">{{ 'inputs.document_expiration_date' | translate }}</label>
        <input type="date" class="form-control" formControlName="document_expiration_date" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <label class="form-label">{{ 'inputs.billing_address' | translate }} <span class="required">*</span></label>
        <input type="text" class="form-control" formControlName="billing_address"
          [placeholder]="'inputs.billing_address' | translate" />
      </div>
      <div class="col-6 col-md-2 mb-3">
        <label class="form-label">{{ 'inputs.billing_postal_code' | translate }} <span class="required">*</span></label>
        <input type="text" class="form-control" formControlName="billing_postal_code"
          [placeholder]="'28001'" maxlength="5" />
      </div>
      <div class="col-6 col-md-2 mb-3">
        <label class="form-label">{{ 'inputs.billing_city' | translate }} <span class="required">*</span></label>
        <input type="text" class="form-control" formControlName="billing_city"
          [placeholder]="'inputs.billing_city' | translate" />
      </div>
      <div class="col-12 col-md-2 mb-3">
        <label class="form-label">{{ 'inputs.billing_state' | translate }} <span class="required">*</span></label>
        <input type="text" class="form-control" formControlName="billing_state"
          [placeholder]="'inputs.billing_state' | translate" />
      </div>
    </div>

    <!-- Assignee (only for organizations) -->
    <div *ngIf="clientForm.value.type === 'organization'" class="mt-4 sub-person-section">
      <h6 class="sub-person-title">{{ 'inputs.assignee' | translate }}</h6>

      <!-- Already assigned -->
      <div *ngIf="assigneeData && assigneeId" class="assigned-person">
        <span><i class="icon-user"></i> {{ assigneeData.name }} {{ assigneeData.lastname }} ({{ assigneeData.tax_id }})</span>
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeAssignee()">
          <i class="icon-cross2"></i>
        </button>
      </div>

      <!-- Search -->
      <div *ngIf="!assigneeId" class="search-person">
        <div class="d-flex align-items-center gap-2 mb-2">
          <input type="text" class="form-control" [(ngModel)]="assigneeTaxIdSearch" [ngModelOptions]="{standalone: true}"
            [placeholder]="'inputs.tax_id' | translate" (keyup.enter)="searchAssigneeByTaxId()" style="flex:1;" />
          <button type="button" class="btn btn-sm btn-ring" [disabled]="searchingAssignee" (click)="searchAssigneeByTaxId()">
            <i class="icon-search"></i> {{ 'buttons.search' | translate }}
          </button>
          <button *ngIf="assigneeNotFound && !showAssigneeForm" type="button" class="btn btn-sm btn-hover" style="background:var(--color-primary-400);color:white;" (click)="showAssigneeForm = true">
            <i class="icon-plus"></i> {{ 'buttons.add+' | translate }}
          </button>
        </div>
        <p *ngIf="assigneeNotFound && !showAssigneeForm" class="text-muted small">
          {{ 'sql_wizard.person_not_found' | translate }}
        </p>

        <!-- Create form -->
        <div *ngIf="showAssigneeForm" class="sub-person-form" [formGroup]="assigneeForm">
          <!-- Dropzone para subir documento -->
          <div class="person-doc-upload mb-3">
            <div class="drop-zone drop-zone-sm"
              (drop)="onPersonDocDrop($event, 'assignee')" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
              (click)="assigneeFileInput.click()">
              <i class="icon-upload2"></i> {{ 'sql_wizard.upload_document_hint' | translate }}
              <input #assigneeFileInput type="file" class="input-file-hidden"
                accept=".pdf,.jpg,.jpeg,.png" (change)="onPersonDocUpload($event, 'assignee')" />
            </div>
          </div>
          <div class="separator-or mb-3">
            <span>{{ 'sql_wizard.or_fill_manually' | translate }}</span>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.tax_id' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="tax_id" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.name' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="name" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.lastname' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="lastname" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.email' | translate }}</label>
              <input type="email" class="form-control form-control-sm" formControlName="email" />
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.phone' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="phone" [placeholder]="'(+34)600000000'" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_address' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_address" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_postal_code' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_postal_code" maxlength="5" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_city' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_city" />
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_state' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_state" />
            </div>
          </div>
          <div class="d-flex gap-2 mt-2">
            <button type="button" class="btn btn-sm btn-ring" (click)="cancelAssigneeForm()">
              {{ 'buttons.cancel' | translate }}
            </button>
            <button type="button" class="btn btn-sm btn-primary" (click)="createAssignee()">
              <i class="icon-plus"></i> {{ 'sql_wizard.create_person' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Guarantee (avalista) -->
    <div class="mt-4 sub-person-section">
      <h6 class="sub-person-title">{{ 'inputs.guarantee' | translate }}</h6>

      <!-- Already assigned -->
      <div *ngIf="guaranteeData && guaranteeId" class="assigned-person">
        <span><i class="icon-user"></i> {{ guaranteeData.name }} {{ guaranteeData.lastname }} ({{ guaranteeData.tax_id }})</span>
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeGuarantee()">
          <i class="icon-cross2"></i>
        </button>
      </div>

      <!-- Search -->
      <div *ngIf="!guaranteeId" class="search-person">
        <p class="text-muted small">{{ 'sql_wizard.guarantee_optional' | translate }}</p>
        <div class="d-flex align-items-center gap-2 mb-2">
          <input type="text" class="form-control" [(ngModel)]="guaranteeTaxIdSearch" [ngModelOptions]="{standalone: true}"
            [placeholder]="'inputs.tax_id' | translate" (keyup.enter)="searchGuaranteeByTaxId()" style="flex:1;" />
          <button type="button" class="btn btn-sm btn-ring" [disabled]="searchingGuarantee" (click)="searchGuaranteeByTaxId()">
            <i class="icon-search"></i> {{ 'buttons.search' | translate }}
          </button>
          <button *ngIf="guaranteeNotFound && !showGuaranteeForm" type="button" class="btn btn-sm btn-hover" style="background:var(--color-primary-400);color:white;" (click)="showGuaranteeForm = true">
            <i class="icon-plus"></i> {{ 'buttons.add+' | translate }}
          </button>
        </div>
        <p *ngIf="guaranteeNotFound && !showGuaranteeForm" class="text-muted small">
          {{ 'sql_wizard.person_not_found' | translate }}
        </p>

        <!-- Create form -->
        <div *ngIf="showGuaranteeForm" class="sub-person-form" [formGroup]="guaranteeForm">
          <!-- Dropzone para subir documento -->
          <div class="person-doc-upload mb-3">
            <div class="drop-zone drop-zone-sm"
              (drop)="onPersonDocDrop($event, 'guarantee')" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
              (click)="guaranteeFileInput.click()">
              <i class="icon-upload2"></i> {{ 'sql_wizard.upload_document_hint' | translate }}
              <input #guaranteeFileInput type="file" class="input-file-hidden"
                accept=".pdf,.jpg,.jpeg,.png" (change)="onPersonDocUpload($event, 'guarantee')" />
            </div>
          </div>
          <div class="separator-or mb-3">
            <span>{{ 'sql_wizard.or_fill_manually' | translate }}</span>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.tax_id' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="tax_id" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.name' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="name" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.lastname' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="lastname" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.email' | translate }}</label>
              <input type="email" class="form-control form-control-sm" formControlName="email" />
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.phone' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="phone" [placeholder]="'(+34)600000000'" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_address' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_address" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_postal_code' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_postal_code" maxlength="5" />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_city' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_city" />
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label form-label-sm">{{ 'inputs.billing_state' | translate }}</label>
              <input type="text" class="form-control form-control-sm" formControlName="billing_state" />
            </div>
          </div>
          <div class="d-flex gap-2 mt-2">
            <button type="button" class="btn btn-sm btn-ring" (click)="cancelGuaranteeForm()">
              {{ 'buttons.cancel' | translate }}
            </button>
            <button type="button" class="btn btn-sm btn-primary" (click)="createGuarantee()">
              <i class="icon-plus"></i> {{ 'sql_wizard.create_person' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- STEP 4: Delivery -->
  <div *ngIf="!loading && currentStep === 3" class="wizard-step" [formGroup]="deliveryForm">
    <h5 class="step-title">{{ 'inputs.delivery' | translate }}</h5>

    <!-- Línea 1: Urgencia + Lugar de entrega -->
    <div class="row d-flex">
      <div class="col-12 col-md-6 mb-3">
        <label class="form-label">{{ 'inputs.delivery_urgency.delivery_urgency' | translate }}</label>
        <ng-select formControlName="delivery_urgency" [items]="deliveryUrgencyOptions" bindValue="key" bindLabel="name"
          [placeholder]="'inputs.delivery_urgency.delivery_urgency' | translate" [searchable]="true" [clearable]="true"
          [notFoundText]="'tables.no_results' | translate">
          <ng-template ng-option-tmp let-item="item">
            {{ 'inputs.delivery_urgency.' + item | translate }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label class="form-label">{{ 'inputs.delivery_place' | translate }}</label>
        <ng-select formControlName="delivery_place" [items]="deliveryPlaceOptions" bindValue="key" bindLabel="name"
          [placeholder]="'inputs.delivery_place' | translate" [searchable]="true" [clearable]="true"
          [notFoundText]="'tables.no_results' | translate">
        </ng-select>
      </div>
    </div>

    <!-- Línea 2: Dirección + Provincia -->
    <div class="row d-flex align-items-end">
      <div class="col-12 col-md-8 mb-3">
        <label class="form-label">{{ 'inputs.delivery_address' | translate }}</label>
        <input type="text" class="form-control" formControlName="delivery_address"
          placeholder="{{ 'inputs.delivery_address' | translate }}" />
      </div>
      <div class="col-12 col-md-4 mb-3">
        <label class="form-label">{{ 'inputs.delivery_state' | translate }}</label>
        <input type="text" class="form-control" formControlName="delivery_state"
          placeholder="{{ 'inputs.delivery_state' | translate }}" />
      </div>
    </div>

    <!-- Línea 3: CP + Localidad -->
    <div class="row d-flex align-items-end">
      <div class="col-12 col-md-6 mb-3">
        <label class="form-label">{{ 'inputs.delivery_postal_code' | translate }}</label>
        <input type="text" class="form-control" formControlName="delivery_postal_code"
          placeholder="{{ 'inputs.delivery_postal_code' | translate }}" />
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label class="form-label">{{ 'inputs.delivery_city' | translate }}</label>
        <input type="text" class="form-control" formControlName="delivery_city"
          placeholder="{{ 'inputs.delivery_city' | translate }}" />
      </div>
    </div>
  </div>

  <!-- STEP 5: Notes -->
  <div *ngIf="!loading && currentStep === 4" class="wizard-step" [formGroup]="notesForm">
    <h5 class="step-title">{{ 'inputs.notes' | translate }}</h5>
    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">{{ 'sql_wizard.notes_placeholder' | translate }}</label>
        <textarea class="form-control" formControlName="notes" rows="5"
          [placeholder]="'sql_wizard.notes_placeholder' | translate"></textarea>
      </div>
    </div>
  </div>

  <!-- STEP 6: Confirmation -->
  <div *ngIf="!loading && currentStep === 5" class="wizard-step">
    <h5 class="step-title">{{ 'buttons.confirm' | translate }}</h5>
    <div class="confirm-summary">
      <!-- Partnership -->
      <div class="summary-section">
        <h6>{{ 'inputs.partnership' | translate }}</h6>
        <div class="summary-row">
          <span>{{ 'inputs.broker' | translate }}:</span>
          <strong>{{ (brokerData | keyvalue)?.length ? (brokerData | slice:0:undefined | keyvalue)?.[0]?.value?.['name'] : partnershipForm.value.broker_id }}</strong>
        </div>
      </div>
      <!-- Vehicle -->
      <div class="summary-section" *ngIf="vehicleForm.value.vehicle || selectedCampaignRef">
        <h6>{{ 'inputs.vehicle' | translate }}</h6>
        <div class="summary-row" *ngIf="vehicleForm.value.vehicle">
          <span>{{ vehicleForm.value.vehicle }}</span>
        </div>
        <div class="summary-row" *ngIf="selectedCampaignRef">
          <span>{{ 'inputs.campaign' | translate }}: {{ selectedCampaignRef }}</span>
        </div>
        <div class="summary-row" *ngIf="vehicleForm.value.duration">
          <span>{{ vehicleForm.value.duration }} {{ 'inputs.month' | translate }} / {{ vehicleForm.value.yearly_kms }} km</span>
        </div>
      </div>
      <!-- Documents -->
      <div class="summary-section">
        <h6>{{ 'inputs.documents' | translate }}</h6>
        <span>{{ orderDocuments.length }} {{ 'inputs.order_documents' | translate }}, {{ clientDocuments.length }} {{ 'inputs.client_documents' | translate }}</span>
      </div>
      <!-- Client -->
      <div class="summary-section">
        <h6>{{ 'inputs.client' | translate }}</h6>
        <div class="summary-row">{{ clientForm.value.name }} {{ clientForm.value.lastname }}</div>
        <div class="summary-row">{{ clientForm.value.tax_id }} — {{ clientForm.value.email }}</div>
        <div class="summary-row">{{ clientForm.value.billing_address }}, {{ clientForm.value.billing_postal_code }} {{ clientForm.value.billing_city }}</div>
      </div>
      <!-- Assignee -->
      <div class="summary-section" *ngIf="assigneeData">
        <h6>{{ 'inputs.assignee' | translate }}</h6>
        <div class="summary-row">{{ assigneeData.name }} {{ assigneeData.lastname }} ({{ assigneeData.tax_id }})</div>
      </div>
      <!-- Guarantee -->
      <div class="summary-section" *ngIf="guaranteeData">
        <h6>{{ 'inputs.guarantee' | translate }}</h6>
        <div class="summary-row">{{ guaranteeData.name }} {{ guaranteeData.lastname }} ({{ guaranteeData.tax_id }})</div>
      </div>
      <!-- Delivery -->
      <div class="summary-section" *ngIf="hasDeliveryData">
        <h6>{{ 'inputs.delivery' | translate }}</h6>
        <div class="summary-row" *ngIf="deliveryForm.value.delivery_urgency">
          <span>{{ 'inputs.delivery_urgency.delivery_urgency' | translate }}:</span>
          <strong>{{ 'inputs.delivery_urgency.' + deliveryForm.value.delivery_urgency | translate }}</strong>
        </div>
        <div class="summary-row" *ngIf="deliveryForm.value.delivery_place">
          <span>{{ 'inputs.delivery_place' | translate }}:</span>
          <strong>{{ getDeliveryPlaceName(deliveryForm.value.delivery_place) }}</strong>
        </div>
        <div class="summary-row" *ngIf="deliveryForm.value.delivery_address">
          <span>{{ 'inputs.delivery_address' | translate }}:</span>
          <strong>{{ deliveryForm.value.delivery_address }}</strong>
        </div>
        <div class="summary-row" *ngIf="deliveryForm.value.delivery_state">
          <span>{{ 'inputs.delivery_state' | translate }}:</span>
          <strong>{{ deliveryForm.value.delivery_state }}</strong>
        </div>
        <div class="summary-row" *ngIf="deliveryForm.value.delivery_postal_code">
          <span>{{ 'inputs.delivery_postal_code' | translate }}:</span>
          <strong>{{ deliveryForm.value.delivery_postal_code }}</strong>
        </div>
        <div class="summary-row" *ngIf="deliveryForm.value.delivery_city">
          <span>{{ 'inputs.delivery_city' | translate }}:</span>
          <strong>{{ deliveryForm.value.delivery_city }}</strong>
        </div>
      </div>
      <!-- Notes -->
      <div class="summary-section" *ngIf="notesForm.value.notes">
        <h6>{{ 'inputs.notes' | translate }}</h6>
        <div class="summary-row">{{ notesForm.value.notes }}</div>
      </div>
    </div>
  </div>

  <!-- Navigation buttons -->
  <div *ngIf="!loading" class="wizard-nav">
    <button *ngIf="currentStep > 0" type="button" class="btn btn-ring" (click)="prevStep()">
      <i class="icon-chevron-left"></i> {{ 'buttons.back' | translate }}
    </button>
    <div class="flex-grow-1"></div>
    <button *ngIf="currentStep < steps.length - 1" type="button" class="btn btn-primary btn-primary-form" (click)="nextStep()">
      {{ 'buttons.next' | translate }} <i class="icon-chevron-right"></i>
    </button>
    <button *ngIf="currentStep === steps.length - 1" type="button" class="btn btn-primary btn-primary-form"
      [disabled]="submitting" (click)="onSubmit()">
      {{ 'buttons.createsql' | translate }}
    </button>
  </div>
</div>
